import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import {connect} from 'react-redux';
import Col from 'antd/es/col';
import Row from 'antd/es/row';
import Modal from 'antd/es/modal';
import Icon from 'antd/es/icon';
import Button from 'antd/es/button';
import message from 'antd/es/message';
import GoogleLogin from 'react-google-login';
import FacebookLogin
  from 'react-facebook-login/dist/facebook-login-render-props';
import {client} from '../../apollo/apolloClient';
import {changeAuthModal} from '../../redux/actions/Util';
import {NavbarSignup} from './NavbarSignup';
import {NavbarLogin} from './NavbarLogin';
import {
  GET_FACEBOOK_ACCESS_TOKEN,
  GET_GOOGLE_ACCESS_TOKEN,
} from '../../apollo/schema';
import {WINDOW_WIDTH} from '../../helpers/util';
import './Navbar.css';
import AppleLogin from 'react-apple-login';

const appleRedirection = process.env.NODE_ENV === 'production' ? 'https://services-new.medcampus.io/api/signin-with-apple' : 'https://api-uat.medcampus.io/api/signin-with-apple';

class NavbarPre extends React.Component {

  state = {
    showSignUpSection: false,
    showSignInSection: false,
    token: '',
    showSidebar: false,
  };

  showLoginModal = () => {
    const {changeAuthModal} = this.props;
    changeAuthModal(true);
  };

  handleOk = () => {
    const {changeAuthModal} = this.props;
    changeAuthModal(true);
  };

  handleCancel = () => {
    const {changeAuthModal} = this.props;
    changeAuthModal(false);
  };

  showHideSidebar = () => {
    this.setState(prevState => ({showSidebar: !prevState.showSidebar}));
  };

  hideSidebar = () => {
    this.setState({showSidebar: false});
  };

  responseGoogle = response => {
    if (!response.hasOwnProperty('error')) {
      let token = response.accessToken;
      client.query({
        query: GET_GOOGLE_ACCESS_TOKEN,
        variables: {token},
      }).then((res) => {
            if (res.hasOwnProperty('errors')) {
              message.error('Something went wrong');
            } else {
              this.props.changeAuthModal(false);
              window.location.reload();
            }
          },
      );
    }
  };

  responseFacebook = response => {
    if (!response.hasOwnProperty('status')) {
      let token = response.accessToken;
      client.query({
        query: GET_FACEBOOK_ACCESS_TOKEN,
        variables: {token},
      }).then((res) => {
            if (res.hasOwnProperty('errors')) {
              message.error('Something went wrong');
            } else {
              this.props.changeAuthModal(false);
              window.location.reload();
            }
          },
      );
    }
  };

  render() {
    const {showSignUpSection, showSignInSection, showSidebar} = this.state;
    const {showAuthModal} = this.props;
    return (
        <div className={'navbar navbar-shadow'}>
          <div className="collapse-trigger">
            <Icon type="menu-unfold" className="mc-icon-large"
                  onClick={this.showHideSidebar}/>
          </div>
          <Link to={'/'} className="navbar-brand">
            <img className="navbar-logo"
                 src={'https://assets-new.medcampus.io/assets/images/medcampus-logo.png'}
                 alt={'MedCampus logo'}
            />
          </Link>
          <div className="rs-triggers" onClick={this.hideSidebar}>
            <button className="join-us" onClick={this.showLoginModal}>Join us
            </button>
          </div>
          <div className={showSidebar ?
              'collapse-wrapped active' :
              'collapse-wrapped'}
               onClick={this.hideSidebar}>
            <div className={showSidebar ? 'collapse active' : 'collapse'}
                 onClick={(e) => e.stopPropagation()}>
              <Icon className="close-navbar" type="close"
                    onClick={this.hideSidebar}/>
              <ul className="navbar-nav">
                <li onClick={this.hideSidebar}><NavLink
                    to={'/challenges/'}>challenges</NavLink></li>
                <li onClick={this.hideSidebar}><NavLink
                    to={'/prepmed/'}>prepMed</NavLink></li>
                <li onClick={this.hideSidebar}><NavLink
                    to={'/medpixx/'}>medPixx</NavLink></li>
                <li onClick={this.hideSidebar}><NavLink
                    to={'/mvideos/'}>mVideos</NavLink></li>
                <li onClick={this.hideSidebar}><NavLink
                    to={'/mnotes/'}>mNotes</NavLink></li>
                {/* <li onClick={this.hideSidebar}><NavLink
                    to={'/playwin/'}>Play & Win</NavLink></li> */}
                <li onClick={this.hideSidebar}><NavLink
                    to={'/medpass/'}>medPass</NavLink></li>
              </ul>
            </div>
          </div>
          <Modal
              className="login-modal"
              title="Sign in to your account"
              visible={showAuthModal}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              afterClose={() => this.setState(
                  {showSignInSection: false, showSignUpSection: false})}
              centered
              width={WINDOW_WIDTH < 960 ? 500 : 950}
              footer={null}
          >
            {
              WINDOW_WIDTH > 960 ? (
                  <Row type="flex" justify="center" align="middle">
                    <Col xs={24} sm={12}>
                      <div className="login-popup-left-section">
                        <img className="login-popup-image"
                             src={'https://assets-new.medcampus.io/assets/images/login-page-image.png'}
                             alt="login background"/>
                      </div>
                    </Col>
                    {showSignUpSection === false ? (
                        <Col xs={24} sm={12}>
                          {showSignInSection === false ? (
                              <div
                                  className="text-center"
                                  style={{
                                    display: 'block',
                                    width: '100%',
                                    maxWidth: 300,
                                    margin: 'auto',
                                  }}
                              >
                                <img
                                    src={'https://assets-new.medcampus.io/assets/images/medcampus-icon.jpg'}
                                    width={150}
                                    alt={'logo'}/>
                                <GoogleLogin
                                    clientId="1024032446363-se4ofiu70op8doke2jd32enqu0tfhgdq.apps.googleusercontent.com"
                                    render={renderProps => <Button
                                        className="mc-mtb-20"
                                        type="primary"
                                        shape="round"
                                        icon="google"
                                        ghost
                                        block
                                        onClick={renderProps.onClick}
                                        disabled={renderProps.disabled}
                                    >Sign in with Google</Button>}
                                    buttonText="Login"
                                    onSuccess={this.responseGoogle}
                                    onFailure={this.responseGoogle}
                                    cookiePolicy={'single_host_origin'}
                                />
                                <FacebookLogin
                                    appId="412213252603352"
                                    fields="name,email,picture"
                                    disableMobileRedirect={true}
                                    callback={this.responseFacebook}
                                    render={props => <Button
                                        className="mc-mb-20"
                                        type="primary"
                                        shape="round"
                                        icon="facebook"
                                        ghost
                                        block
                                        onClick={props.onClick}
                                    >Sign in with Facebook</Button>}
                                />
                                <AppleLogin
                                    clientId={'org.medcampus.medcampus'}
                                    redirectURI={appleRedirection}
                                    scope={'name email'}
                                    responseType={'code id_token'}
                                    responseMode={'form_post'}
                                    render={props => <Button
                                        className="mc-mb-20"
                                        type="primary"
                                        shape="round"
                                        icon="apple"
                                        ghost
                                        block
                                        onClick={props.onClick}
                                    >Sign in with Apple</Button>}
                                />
                                <Button
                                    className="mc-mb-20"
                                    type="primary"
                                    shape="round"
                                    icon="mail"
                                    ghost
                                    block
                                    onClick={() => this.setState(
                                        {showSignInSection: true})}
                                >Sign in with Email</Button>
                                <p>Not a member? <span
                                    style={{
                                      color: '#1890ff',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => this.setState(
                                        {showSignUpSection: true})}>Create one</span>
                                </p>
                              </div>
                          ) : (
                              <div className="form-block">
                                <NavbarLogin
                                    handleFormDisplay={() => this.setState({
                                      showSignInSection: false,
                                      showSignUpSection: true,
                                    })}/>
                              </div>
                          )}
                        </Col>
                    ) : (
                        <Col xs={24} sm={12}>
                          <div className="form-block">
                            <NavbarSignup
                                handleFormDisplay={() => this.setState({
                                  showSignInSection: false,
                                  showSignUpSection: false,
                                })}/>
                          </div>
                        </Col>
                    )}
                  </Row>
              ) : <Row type="flex" justify="center" align="middle">
                {showSignUpSection === false ? (
                    <Col xs={24} sm={12}>
                      {showSignInSection === false ? (
                          <div
                              className="text-center"
                              style={{
                                display: 'block',
                                width: '100%',
                                maxWidth: 300,
                                margin: 'auto',
                                padding: 20,
                              }}
                          >
                            <img
                                src={'https://assets-new.medcampus.io/assets/images/medcampus-icon.jpg'}
                                width={150}
                                alt={'logo'}
                            />
                            <GoogleLogin
                                clientId="1024032446363-se4ofiu70op8doke2jd32enqu0tfhgdq.apps.googleusercontent.com"
                                render={renderProps => (
                                    <Button
                                        className="mc-mtb-20"
                                        type="primary"
                                        shape="round"
                                        icon="google"
                                        ghost
                                        block
                                        onClick={renderProps.onClick}
                                        disabled={renderProps.disabled}
                                    >Sign in with Google</Button>
                                )}
                                buttonText="Login"
                                onSuccess={this.responseGoogle}
                                onFailure={this.responseGoogle}
                                cookiePolicy={'single_host_origin'}
                            />
                            <FacebookLogin
                                appId="412213252603352"
                                fields="name,email,picture"
                                disableMobileRedirect={true}
                                callback={this.responseFacebook}
                                render={renderProps => (
                                    <Button
                                        className="mc-mb-20"
                                        type="primary"
                                        shape="round"
                                        icon="facebook"
                                        ghost
                                        block
                                        onClick={renderProps.onClick}
                                    >Sign in with Facebook</Button>
                                )}
                            />
                            <AppleLogin
                                clientId={'org.medcampus.medcampus'}
                                redirectURI={appleRedirection}
                                scope={'name email'}
                                responseType={'code id_token'}
                                responseMode={'form_post'}
                                render={props => <Button
                                    className="mc-mb-20"
                                    type="primary"
                                    shape="round"
                                    icon="apple"
                                    ghost
                                    block
                                    onClick={props.onClick}
                                >Sign in with Apple</Button>}
                            />
                            <Button
                                className="mc-mb-20"
                                type="primary"
                                shape="round"
                                icon="mail"
                                ghost
                                block
                                onClick={() => this.setState(
                                    {showSignInSection: true})}
                            >Sign in with Email</Button>
                            <p>Not a member? <span
                                style={{color: '#1890ff', cursor: 'pointer'}}
                                onClick={() => this.setState(
                                    {showSignUpSection: true})}>Create one</span>
                            </p>
                          </div>
                      ) : (
                          <div className="form-block">
                            <NavbarLogin
                                handleFormDisplay={() => this.setState({
                                  showSignInSection: false,
                                  showSignUpSection: true,
                                })}
                            />
                          </div>
                      )}
                    </Col>
                ) : (
                    <Col xs={24} sm={12}>
                      <div className="form-block">
                        <NavbarSignup handleFormDisplay={() => this.setState({
                          showSignInSection: false,
                          showSignUpSection: false,
                        })}/>
                      </div>
                    </Col>
                )}
              </Row>
            }
          </Modal>
        </div>
    );
  }
}

const mapStateToProps = state => {
  return state.util;
};

const Navbar = connect(mapStateToProps, {changeAuthModal})(NavbarPre);

export {Navbar};
